module.exports = require('./convert')(
  ".exportsfunc'(),/;<>?BCDFGHJKLMNPTVYZ[]`abdghijklmqvwyz{}~",
  "زثءحخقفسبعىؤط)(وظك,.؟لآ}][لأأـ،/’آ؛لإ{إ~جدذشلايلاهتنمةضرصغئ<>ّ"
)
